"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "THEME": "Britannia",
    "TRADEMARK": "Britannia Insurance is arranged, underwritten and administered by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company, registered in England and Wales number 3232514. Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, register number 202965. Registered address: 57 Ladymead, Guildford, Surrey, GU1 1DB. Britannia Insurance is a trading name of Liverpool Victoria Insurance Company Limited.",
    "WHATEVER_YOU_DECIDE": "Whatever you decide, we’ll make it happen.",
    "COMPLAINT_EMAIL": "digitalhelp@britanniainsurance.co.uk",
    "HELP_EMAIL": "digitalhelp@allianz.co.uk",
    "UNDERWRITER": "underwritten by Liverpool Victoria Insurance Company Limited which is an Allianz Group company",
    "FAQ_CAR_URL": "https://www.britanniainsurance.co.uk/car-insurance/faqs.html ",
    "FAQ_HOME_URL": "Britannia Home FAQ URL",
    "CONTACT_US_URL": "https://www.britanniainsurance.co.uk/car-insurance/contact-us.html",
    "PRIVACY_NOTICE_URL": "https://www.britanniainsurance.co.uk/privacy-notice.html",
    "LEGAL_NOTICE_URL": "https://www.britanniainsurance.co.uk/legal.html",
    "COOKIE_POLICY_URL": "https://www.britanniainsurance.co.uk/cookie-policy.html",
    "PRODUCT": "Britannia",
    "TIER_1": "Essentials",
    "TIER_2": "Britannia",
    "TIER_3": "Premier",
    "PRODUCT_TIER_1": "Britannia Essentials",
    "PRODUCT_TIER_2": "Britannia",
    "PRODUCT_TIER_3": "Britannia Premier",
    "CREDIT_WORDING": "Credit supplied by LVIC Limited, which is an Allianz Group company",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_DISPLAY": "0330 678 5557",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_TEL": "tel:03306785557",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_DISPLAY": "(+44) 120 284 8509",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_TEL": "tel:+441202848509",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_DISPLAY": "0330 678 7154",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_TEL": "tel:03306787154",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_DISPLAY": "(+44) 1484 435806",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_TEL": "tel:+441484435806",
    "BRAND_URL": "https://www.britanniainsurance.co.uk",
    "LET_US_KNOW_URL": "https://cloud.comms.britanniainsurance.co.uk/renewalcapture",
    "HOW_TO_VIDEOS": {
        "REPLACE_CAR": "https://www.youtube.com/embed/SvgnX6fVGzw",
        "ADD_DRIVER": "https://www.youtube.com/embed/CCFNmQEx4Xs",
        "CHANGE_NUMBER_PLATE": "https://www.youtube.com/embed/h5cawbL0w44"
    },
    "DOCUMENTS_TITLE": "Documents"
};
//# sourceMappingURL=resource.js.map